import faker from 'faker';
import moment from 'moment';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            id: index,
            nf: faker.random.number({min: 10000, max: 5000}),
            numeroParcela: faker.random.number({min: 1, max: 36}),
            dataEmissaoNF: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            codigoFornecedor: faker.random.number({min: 100, max: 800}),
            nomeFornecedor: faker.name.findName(),
            ct: faker.random.number({min: 100, max: 500}),
            analistaGpc: faker.name.findName(),
            area: faker.address.stateAbbr(),
            dataPrevPagam:  moment(faker.date.recent(10)).format('DD/MM/YYYY'),
            valorNF: faker.random.number({min: 10000, max: 20000, precision: 0.01}).toFixed(2)
        })
    });